export const NO_SEARCHES_MESSAGE = 'No searches saved';
export const RESULTS = 'results';
export const RESULT = 'result';
export const HIDE_SEARCHES_TEXT = 'Hide saved configurations';
export const SHOW_SEARCHES_TEXT = 'Show saved configurations';
export const LOAD_SEARCH_TEXT = 'Load this search';
export const DELETE_SEARCH_TEXT = 'Delete this search';
